import axios from 'axios';

export function getMyCertificates() {
  return axios.get('/api/v2/certificates/me');
}
